import { Box } from '@material-ui/core';
import Layout from '../../../layout';

import useStyles from './styles';

const FROTA_EMAIL = 'frotaexecutiva@pepsico.com';
const FROTA_WHATSAPP = '(11) 97535-2492';
const FROTA_WHATSAPP_LINK = 'https://wa.me/5511975352492';

const FleetsQA = () => {
  const classes = useStyles();

  const email = (
    <a href={`mailto:${FROTA_EMAIL}`} target="_blank" rel="noreferrer">
      {FROTA_EMAIL}
    </a>
  );

  const whatsapp = (
    <a href={FROTA_WHATSAPP_LINK} target="_blank" rel="noreferrer">
      {FROTA_WHATSAPP}
    </a>
  );

  return (
    <Layout page="fleetsQA">
      <Box className={classes.container} textAlign="justify">
        <h3 className={classes.title}>
          Quais funcionários(as) estão elegíveis a compra de um carro?
        </h3>

        <br />

        <p className={classes.paragraph}>
          A compra será possível somente para funcionário(as) L09 e abaixo,
          ativos ou em afastamento por período de até 6 meses da data da
          divulgação do processo, maiores de 18 anos. Funcionários(as)
          afastados(as) por mais de 6 meses não serão elegíveis.
        </p>

        <br />

        <p className={classes.paragraph}>
          O(a) funcionário(a) pode escolher até 3 (três) veículos, sendo
          importante sinalizar qual a sua prioridade. Após o cadastro, o
          critério de definição para a venda do veículo será:
        </p>

        <br />

        <ol className={classes.lists}>
          <li>maior tempo de empresa;</li>
          <li>menor nível;</li>
          <li>
            data de inscrição no link ou app definidos pela empresa para
            inscrição.
          </li>
        </ol>

        <br />

        <h3 className={classes.title}>Posso adquirir mais de um carro?</h3>

        <br />

        <p className={classes.paragraph}>
          Não. Será somente um carro por funcionário(a).
        </p>

        <br />

        <p className={classes.paragraph}>
          O(a) funcionário(a) poderá selecionar até 3 (três) carros de seu
          interesse, porém somente um carro poderá ser adquirido de acordo com o
          critério estabelecido por ordem de prioridade.
        </p>

        <br />

        <h3 className={classes.title}>
          Como devo efetuar o pagamento do carro?
        </h3>

        <br />

        <p className={classes.paragraph}>
          O pagamento deverá ser efetuado em até 5 dias úteis, após o
          recebimento da confirmação por e-mail.
        </p>

        <br />

        <p className={classes.paragraph}>
          A quantia deverá ocorrer via depósito ou transferência em conta
          corrente da Pepsico. Os dados serão enviados por e-mail aos
          contemplados(as) um dia após o encerramento da ação, informando o
          prazo.
        </p>

        <br />

        <h3 className={classes.title}>
          Fui contemplado(a), quais documentos devo enviar para iniciar o
          processo? A quem devo enviar?
        </h3>

        <br />

        <p className={classes.paragraph}>
          Os documentos necessários para início do processo são: Comprovante de
          residência, comprovante de pagamento e Cópia da CNH.
        </p>

        <br />

        <p className={classes.paragraph}>
          Os documentos deverão ser enviados para <strong>{email}</strong>
        </p>

        <br />

        <h3 className={classes.title}>
          Posso transferir o carro diretamente a um terceiro(a)?
        </h3>

        <br />

        <p className={classes.paragraph}>
          Não. A primeira transferência deve ser da Pepsico para o(a)
          funcionário(a) contemplado(a).
        </p>

        <br />

        <p className={classes.paragraph}>
          Após concluído 100% do processo de transferência, o(a) funcionário(a)
          poderá realizar nova transferência a quem desejar.
        </p>

        <br />

        <h3 className={classes.title}>Onde devo retirar o carro?</h3>

        <br />

        <p className={classes.paragraph}>
          Os carros estarão disponíveis para retirada na Avenida Juscelino
          Kubitscheck, 180 – São Paulo - SP - Escritório Central da Pepsico.
        </p>

        <br />

        <p className={classes.paragraph}>
          A retirada deverá ser agendada com o time de Facilities pelo e-mail{' '}
          {email} ou WhatsApp {whatsapp}
        </p>

        <br />

        <h3 className={classes.title}>
          Moro em outro estado, como devo fazer para retirar o carro?
        </h3>

        <br />

        <p className={classes.paragraph}>
          Caso não tenha como vir pessoalmente por estar em outro estado,
          orientamos a contratação de um caminhão cegonha com seguro que atenda
          ao tipo de transporte. Todo o custo é do(a) funcionário(a)
          contemplado(a) e a Pepsico irá somente apoiar com a entrega do carro
          ao fornecedor. A responsabilidade do transporte é 100% do(a)
          funcionário(a).
        </p>

        <br />

        <h3 className={classes.title}>
          Posso avaliar o carro presencialmente antes de me inscrever?
        </h3>

        <br />

        <p className={classes.paragraph}>
          Não serão permitidas visitas presenciais, porém todas as informações
          necessárias a respeito dos carros estão bem completas através das
          imagens e laudos disponíveis.
        </p>

        <br />

        <h3 className={classes.title}>
          Quanto tempo leva o processo de transferência?
        </h3>

        <br />

        <p className={classes.paragraph}>
          O processo de transferência leva em média 45 dias, porém esse prazo
          pode ser alterado de acordo com a documentação correta enviada pelo(a)
          funcionário(a); disponibilidade para atender aos prazos de assinaturas
          estabelecidos; documentação do exército válida para carros blindados;
          e quando houver um processo intercompany.
        </p>

        <br />

        <h3 className={classes.title}>O que é um processo intercompany?</h3>

        <br />

        <p className={classes.paragraph}>
          Esse processo será necessário caso o(a) funcionário(a) da empresa
          Pepsico do Brasil, seja BR10 ou BR16, seja contemplado(a) com um carro
          que está em nome da empresa Pepsicola (válido também para a situação
          inversa).
        </p>

        <br />

        <p className={classes.paragraph}>
          Serão dois processos de transferência. Exemplo: de Pepsicola para PDB
          e em seguida da PDB para o(a) funcionário(a).
        </p>

        <br />

        <h3 className={classes.title}>
          Em quanto tempo devo acionar um seguro pessoal?
        </h3>

        <br />

        <p className={classes.paragraph}>
          O seguro pessoal deverá ser acionado após o pagamento e envio da
          documentação a Pepsico.
        </p>

        <br />

        <h3 className={classes.title}>Posso parcelar o valor do carro?</h3>

        <br />

        <p className={classes.paragraph}>
          Não. O pagamento deverá ser a vista no prazo estabelecido da ação.
        </p>

        <br />

        <h3 className={classes.title}>
          Em quantos dias posso retirar o carro no Escritório EC-Unico?
        </h3>

        <br />

        <p className={classes.paragraph}>
          Assim que o comprovante de pagamento estiver disponível e o valor 100%
          creditado na conta da Pepsico.
        </p>

        <br />

        <h3 className={classes.title}>
          Quem devo acionar para dúvidas com o processo?
        </h3>

        <br />

        <p className={classes.paragraph}>
          Dúvidas serão atendidas somente e exclusivamente pela SPA – Frota
          Executiva ({email}) ou WhatsApp {whatsapp}
        </p>

        <br />

        <h3 className={classes.title}>Quais são as etapas de transferência?</h3>

        <br />

        <p className={classes.paragraph}>
          Os contemplados(as) receberão um e-mail com informações e prazos de
          documentações necessários.
        </p>

        <br />

        <p className={classes.paragraph}>
          Com os documentos recebidos, o time de Facilities iniciará todo o
          processo operacional, seguindo os passos abaixo:
        </p>

        <br />

        <ol className={classes.lists} type="a">
          <li>Solicitação e validação da área de Ativos.</li>
          <br />
          <li>Cadastro do funcionário(a) no SAP</li>
          <br />
          <li>
            Solicitação de emissão de nota fiscal de venda, junto ao Formulário
            AF-07 e nota fiscal de compra do veículo pela Pepsico.
          </li>
          <br />
          <li>Emissão da Nota Fiscal.</li>
          <br />
          <li>
            Acionar o cartório para assinatura e reconhecimento de firma dos
            procuradores no documento ATPV.
          </li>
          <br />
          <li>
            Solicitar Laudo do veículo e assinatura do CRV com Firma reconhecida
            ao funcionário(a).
          </li>
          <br />
          <li>
            Funcionário(a) providencia laudo de vistoria do veículo, assina CRV
            e reconhece firma em cartório.
            <br />
            Observação: se o(a) funcionário(a) residir em São Paulo - Capital, o
            laudo e documentos são encaminhados para Facilities seguir com a
            transferência; Se residir em outras localidades, o colaborador é o
            responsável por seguir com a transferência, ficando responsável por
            nos enviar as cópias dos documentos (autenticação da CRV assinada e
            cópia simples do laudo).
            <br />
            Para proteção de ambos (Pepsico e colaborador), solicitaremos ao
            despachante a comunicação de venda do veículo para os casos fora de
            São Paulo - Capital.
          </li>
          <br />
          <li>
            Processo com despachante:
            <ol type="i">
              <li>
                SP Capital - Facilities encaminha documentos ao despachante para
                seguir com a transferência. Prazo: 10 dias úteis.
              </li>
              <li>
                Outras localidades - Facilities encaminha kit para que o(a)
                funcionário(a) efetue a transferência, através de um despachante
                ou diretamente.
              </li>
            </ol>
          </li>
        </ol>

        <br />

        <p className={classes.paragraph}>
          O funcionário(a) terá até 30 dias para realizar a transferência para
          seu nome, enviando a comprovação para o time de Facilities através do
          e-mail {email}
        </p>

        <br />

        <h3 className={classes.title}>
          Não consegui realizar o pagamento no dia da ação, o que devo fazer?
        </h3>

        <br />

        <p className={classes.paragraph}>
          Entrar em contato imediatamente com o time responsável através do
          e-mail SPA - Frota Executiva {email} ou WhatsApp {whatsapp} e
          sinalizar sua dificuldade.
        </p>

        <br />

        <p className={classes.paragraph}>
          Não será aceito pagamento com atraso.
        </p>

        <br />

        <h3 className={classes.title}>
          Perdi o prazo de pagamento, o que acontece?
        </h3>

        <br />

        <p className={classes.paragraph}>
          No caso de perda do prazo, o contemplado(a) perde o direito de compra
          e o carro será direcionado a pessoa em lista de espera na prioridade
          dos critérios estabelecidos.
        </p>
      </Box>
    </Layout>
  );
};

export default FleetsQA;
